import React, { useState,Fragment } from "react";
import {
  Row,
  Col,
  Card,
  Container,
  Jumbotron,
  Button,
  Image,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import { FcPhoneAndroid } from "react-icons/fc";
import { DiAndroid, DiApple } from "react-icons/di";

export default (props) => {
  const data=props.data;
  return (
    <Fragment>
      <section >
        <Row>
          <Col>
            <h3 className="section-title">{data.ourServiceTitle || 'Our Services'}</h3>
            <h5 className="section-title">{data.ourServiceSubTitle || ''}</h5>
          </Col>
        </Row>
        <Container>
          <Row id="services">
            <Col md={4}>
              <Card className="service-card">
                <Card.Body>
                  <Card.Title>{data.serviceTitle1 || ''}</Card.Title>
                  <Card.Text>
                    {data.serviceDescription1 || ''}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="service-card">
                <Card.Body>
                  <Card.Title>{data.serviceTitle2 || ''}</Card.Title>
                  <Card.Text>
                    {data.serviceDescription2 || ''}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="service-card">
                <Card.Body>
                  <Card.Title>{data.serviceTitle3|| ''}</Card.Title>
                  <Card.Text>
                    {data.serviceDescription3 || ''}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            </Row>
        </Container>
      </section>
      <section className="order-call">
        <Row style={{ marginTop: 60 }}>
          <Col>
            <Jumbotron>
              <h1> {data.areYouReadyTitle || ''}</h1>
              <p>{data.areYouReadySubTitle || ''}</p>
              <p>
                <Link to="/order" >
                <Button variant="warning" className='order-btn' type="submit">
                {data.orderNowbtntxt || 'Order Now'}

            </Button>
                </Link>
              </p>
            </Jumbotron>
          </Col>
        </Row>
      </section>
      <section className="app-download" id="mobileapps">
        <Row style={{ marginTop: 30 }}>
          <Col>
            <Card className="service-card">
              <Row>
                <Col md={8}>
                  <Card.Body>
                    <Card.Title>
                      <h1>Download Our Free Mobile Apps </h1>
                    </Card.Title>
                    <Card.Text>
                      Stil confused? Download a free lite version to get
                      started!
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer className="text-muted">
                    <Button variant="outline-warning app-download">
                      <DiAndroid></DiAndroid> Android App
                    </Button>
                    <Button variant="outline-warning app-download">
                      <DiApple></DiApple> IOS App
                    </Button>
                  </Card.Footer>
                </Col>
                <Col md={4}>
                  <Image
                    src={require("../assets/img/cell-phone.jpg")}
                    style={{ height: 250, width: "100%" }}
                  ></Image>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </section>
    </Fragment>
  );
};
